// hero-resizer.ts
export function initHeroResizer() {
    const hero = document.querySelector<HTMLElement>("[data-hero]");
    if (!hero) return; // stop if no [data-hero]

    const sublinks = document.querySelector<HTMLElement>("[data-sublinks]");

    function resizeHero() {
        const sublinksHeight = sublinks ? Math.min(sublinks.offsetHeight, 112) : 0;
        hero.style.height = `calc(100dvh - ${sublinksHeight}px)`;
    }

    // Run on load
    window.addEventListener("DOMContentLoaded", resizeHero);

    // Run on resize
    window.addEventListener("resize", resizeHero);

    // Run immediately in case DOM is already ready
    if (document.readyState !== "loading") {
        resizeHero();
    }
}
